import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
import santander from '../../assets/img/brand/santander.png';
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
import ComponentemodificaUsu from './modificaUsuario.js'


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
import basePerfiles from "./basePerfiles.js";
import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
import baseTransaccionPen from "./baseTransaccionesPen.js";
import { event } from "jquery";

const Compotp=(props)=>{
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const [muestramodal,setmuestramodal]=useState(false);
  const [posicionesotp,setposicionesotp]=useState(["","","","","",""]);
  const [mensajepadre,setmensajepadre]=useState(props.mensaje);
  const [cargando,setcargando]=useState(props.esperando);

  useEffect(()=>{
    if(props.pideotp){
      setmuestramodal(true);
    }

  },props.pideotp);

  const toggleModal=()=>{
    if(muestramodal){
      setmuestramodal(false);
      props.funcrespadre("");
    }else{
      setmuestramodal(true);
    }
  }

  const tipeaotp=(event)=>{
    let arrayotp=[...posicionesotp];
    switch(event.target.name){
      case "ref1":
        
        arrayotp[0]=event.target.value;
        if(event.target.value.length>0){
          ref2.current.focus();
          
        }

        break;
      case "ref2":
        arrayotp[1]=event.target.value;
        if(event.target.value.length>0){
          ref3.current.focus();
          
        }

        break;
      case "ref3":
        arrayotp[2]=event.target.value;
        if(event.target.value.length>0){
          ref4.current.focus();
          
        }

        break;
      case "ref4":
        arrayotp[3]=event.target.value;
        if(event.target.value.length>0){
          ref5.current.focus();
          
        }

        break;
      case "ref5":
        arrayotp[4]=event.target.value;
        if(event.target.value.length>0){
          ref6.current.focus();
          
        }

        break;
      case "ref6":
        arrayotp[5]=event.target.value;

      break;
    }
    setposicionesotp([...arrayotp]);
    console.log(event);
  }
  const salidapadre=()=>{
    let cadena=""
    console.log(posicionesotp);
    for(let i=0;i<posicionesotp.length;i++){
      cadena=cadena + posicionesotp[i];
    }
    setmuestramodal(false);
    props.funcrespadre(cadena);
  }
  if(cargando==false){
    //toggle={() => toggleModal()}
    return(
      <Modal
        className="modal-dialog-centered"
        contentClassName=""
        isOpen={muestramodal}
      >
        <div className="modal-header"style={{height:"60px",margin:"-15px 0px 0px 285px"}}>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
              <img
                           className=""
                           src={
                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                            }/></span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-1 text-center">
          <img
              className=""
              src={
                  require("../../assets/img/icons/Icono-Contrasen╠âa-Gris.png")
                  .default
                  }/>                          
            <h4 className="heading mt-4 mb-4">{mensajepadre}</h4>
            
            <div class="code-group mb-0">
              <div class="inputs-icons">
                <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref1} onChange={tipeaotp} name="ref1" autocomplete="off"/>
                <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref2} onChange={tipeaotp} name="ref2" autocomplete="off"/>
                <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref3} onChange={tipeaotp} name="ref3" autocomplete="off"/>
                <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref4} onChange={tipeaotp} name="ref4" autocomplete="off"/>
                <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref5} onChange={tipeaotp} name="ref5" autocomplete="off"/>
                <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref6} onChange={tipeaotp} name="ref6" autocomplete="off"/>
              </div>
            </div>
            <div class="text-center">
              <button  color="white" block size="lg" className="my-title my-1 mt-1 btn bg-success text-white " onClick={salidapadre}>
                Verificar Transacción
                </button>
            </div>
           
          </div>
        </div>
      </Modal>
    )
  }else{
    return(
      <Modal
        className="modal-dialog-centered"
        contentClassName=""
        isOpen={muestramodal}
      >
        <div className="modal-header">
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
              <img
                          className=""
                          src={
                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                            }/></span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i className="fas fa-lock ni-3x" />
            <h4 className="heading mt-4">{mensajepadre}</h4>
            <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%" }}>
                <div style={{ "text-align": "center", top: "10%", position: "relative"  }}>
                    <img style={{height:"100px", }} src={require("../../assets/img/icons/LoaderIDEA.gif").default}></img>
                </div>
                
            </div>
            {//<Skeleton height={100} count={2} className="card-transaction-info" style={{ width:"-webkit-fill-available"}}></Skeleton>
            }
          </div>
        </div>
      </Modal>
    )
  }
  
}

export default Compotp;